import { useNavigate, NavigateFunction } from 'react-router-dom';

export let globalNavigate: NavigateFunction;
// eslint-disable-next-line
export const GlobalHistory = () => {
  globalNavigate = useNavigate();

  return null;
};
